import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Config851DataService {

  constructor(private http: HttpClient) {}

  // CRITICAL: Accept filterParams and rowData parameters
  saveConfigDataForm(
    baseUrl: string,
    saveData: any,
    globalService: any,
    filterParams: any,
    rowData: any,
    settingsObj: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=3ou9ch`;

    // Build AngularJS-compatible payload structure
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ clob_data: JSON.stringify(saveData) }, params);
    params = _.extend({ clob_settings: JSON.stringify(settingsObj) }, params);

    // Build checkLockedbj from real rowData
    const checkLockedbj = [{
      leid: rowData?.LEID || rowData?.SOURCE_LEID,
      cdr_number: rowData?.CDR_NO || rowData?.TAX_CODE,
      consol_group_key: String(rowData?.CONSOL_GROUP_KEY || ''),
      reporting_period: String(rowData?.REPORTING_PERIOD || ''),
      combination_key: String(rowData?.COMBINATION_KEY || ''),
      scenario_key: parseInt(filterParams?.scenario || 0)
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);
    params.is_issue_key_enabled = 'N';
    params.scenario_code = saveData.SCENARIO_CODE || filterParams?.scenario_code || globalService?.globalParams?.scenariocode;
    params.scenario = saveData.SCENARIO || filterParams?.scenario || globalService?.globalParams?.scenario;
    params.tax_year = saveData.TAX_YEAR || filterParams?.tax_year || globalService?.globalParams?.tax_year;
    params.jcd_key = saveData.JCD_KEY || filterParams?.jcd_key || globalService?.globalParams?.jcd_key;
    params.jcd_ta_key = saveData.JCD_TA_KEY || filterParams?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key;
    params.screen_key = saveData.SCREEN_KEY || filterParams?.screen_key || globalService?.globalParams?.screen_key;
    params.screen_type = saveData.SCREEN_TYPE || filterParams?.screen_type || globalService?.globalParams?.screen_type || 'grid';
    // params.process_name = saveData.PROCESS_NAME || filterParams?.process_name || globalService?.globalParams?.process_name;
    // params.filing_key = saveData.FILING_KEY || filterParams?.filing_key || globalService?.globalParams?.filing_key;
    //params.parent_me_string = saveData.PARENT_ME_STRING;
    //params.entity_type = saveData.ENTITY_TYPE;

    if (rowData?.CONSOL_GROUP_KEY) {
      params.filing_key = rowData.CONSOL_GROUP_KEY;
    }

    console.log(params, 'params');

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      urlEncoded.set(key, params[key]);
    });

    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    return this.http.post<any>(url, urlEncoded.toString(), { ...httpOptions, withCredentials: true });
  }

  // Load scenario type codes
  loadScenarioTypeCode(
    baseUrl: string,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const baseParams: any = {
      action_id: 32735,
      action_code: '73pnl0',
      tax_year: filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR,
      scenario: filterParams?.scenario || globalService?.scenario || rowData?.scenario,
      scenario_code: filterParams?.scenario_code || globalService?.scenario_code || rowData?.scenario_code,
      scenario_desc: '',
      is_locked: 'N',
      issue_id: '',
      issue_id_for_tx_save: '',
      is_issue_key_enabled: filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || rowData?.is_issue_key_enabled,
      issue_short_desc: '',
      jcd_key: globalService?.jcd_key || rowData?.JCD_KEY || '',
      jcd_ta_key: globalService?.jcd_ta_key || '',
      screen_key: globalService?.screen_key || '',
      screen_type: 'grid'
    };

    // Build checkLockedbj from real rowData
    const checkLockedbj = [{
      leid: rowData?.LEID || rowData?.SOURCE_LEID,
      cdr_number: rowData?.CDR_NO || rowData?.TAX_CODE,
      consol_group_key: String(rowData?.CONSOL_GROUP_KEY || ''),
      reporting_period: String(rowData?.REPORTING_PERIOD || ''),
      combination_key: String(rowData?.COMBINATION_KEY || ''),
      scenario_key: parseInt(filterParams?.scenario || 0)
    }];
    baseParams.checkLockedbj = JSON.stringify(checkLockedbj);

    // 🚀 CRITICAL: Build URL with query parameters for GET request
    const queryParams = new URLSearchParams();
    Object.keys(baseParams).forEach(key => {
      if (baseParams[key] !== null && baseParams[key] !== undefined) {
        queryParams.set(key, baseParams[key]);
      }
    });

    const url = `${baseUrl}/loadJsonObject?${queryParams.toString()}`;

    return this.http.get<any>(url);
  }

  // Load scenario description
  loadScenarioDesc(
    baseUrl: string,
    scenarioTypeCode: string,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const baseParams: any = {
      action_id: 32735,
      action_code: '73pnl0',
      tax_year: filterParams?.tax_year || globalService?.tax_year || rowData?.TAX_YEAR,
      scenario_type_code: scenarioTypeCode,
      scenario_desc: '',
      is_locked: 'N',
      issue_id: '',
      issue_id_for_tx_save: '',
      issue_short_desc: '',
      jcd_key: globalService?.jcd_key || rowData?.JCD_KEY || '',
      jcd_ta_key: globalService?.jcd_ta_key || '',
      screen_key: globalService?.screen_key || '',
      screen_type: 'grid'
    };

    // Build checkLockedbj from real rowData
    const checkLockedbj = [{
      leid: rowData?.LEID || rowData?.SOURCE_LEID,
      cdr_number: rowData?.CDR_NO || rowData?.TAX_CODE,
      consol_group_key: String(rowData?.CONSOL_GROUP_KEY || ''),
      reporting_period: String(rowData?.REPORTING_PERIOD || ''),
      combination_key: String(rowData?.COMBINATION_KEY || ''),
      scenario_key: parseInt(filterParams?.scenario || 0)
    }];
    baseParams.checkLockedbj = JSON.stringify(checkLockedbj);

    // 🚀 CRITICAL: Build URL with query parameters for GET request
    const queryParams = new URLSearchParams();
    Object.keys(baseParams).forEach(key => {
      if (baseParams[key] !== null && baseParams[key] !== undefined) {
        queryParams.set(key, baseParams[key]);
      }
    });

    const url = `${baseUrl}/loadJsonObject?${queryParams.toString()}`;

    return this.http.get<any>(url);
  }
}
